import { type AvailabilitySlotStatusProperties } from "./getAvailabilitySlotStatus";
import isSlotAvailable from "./isSlotAvailable";

type DayAvailabilityStatus = "loading" | "available" | "unavailable";

export default function getDayAvailabilityStatus(
  dayAvailability: AvailabilitySlotStatusProperties[] | undefined | null,
  people?: number,
): DayAvailabilityStatus {
  // busy loading
  if (dayAvailability === undefined) {
    return "loading";
  }

  // loaded but not available
  if (dayAvailability === null) {
    return "unavailable";
  }

  // A day only counts as available when at least one slot is bookable for the
  // selected party size, using `dinersAvailable` as the source of truth when
  // that field exists.
  const hasSomeAvailability = dayAvailability.some((slot) => {
    if (slot === null) {
      return false;
    }

    return isSlotAvailable(slot, people);
  });
  if (hasSomeAvailability) {
    return "available";
  }

  return "unavailable";
}
